module.exports = __webpack_public_path__ + "25cd93f7115cd124ed39b11e28a79f0f.jpg";